import {Injectable} from '@angular/core';
import {catchError, mergeMap, Observable, of} from 'rxjs';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot,} from '@angular/router';

import {AuthRepository} from './auth.repository';
import {AuthService} from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuestGuard implements CanActivate {
  private navigationAttempted = false;
  constructor(
    private router: Router,
    private authService: AuthService,
    private authRepository: AuthRepository,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot) {
    if (route.queryParamMap.get('redirect') === 'false') return true

   if (this.navigationAttempted) {
    return of(true);
  }
  this.navigationAttempted = true;
    return this.authRepository.userMe().pipe(
      mergeMap(() => this.userSingIn()),
      catchError(() => {
        this.navigationAttempted = true;
        return this.authService.authError()
      })
    );
  }

  private userSingIn(): Observable<boolean> {
    const searchParams = new URLSearchParams(window.location.search);
    const redirectUrl =  searchParams.get('redirect')
  this.router.navigate(['/companies'], {
    queryParams: { redirect: redirectUrl || 'false', queryParamsHandling: 'merge' },});
    return of(false);
  }
}
